// Shared catalog of franchise + dealer opportunities

export const OPPORTUNITIES = {
  franchise: {
    id: "franchise",
    label: "Franchise",
    title: "Franchise Opportunities",
    tagline: "Own the next-gen clean energy footprint of India.",
    desc: "Build, brand and operate INDIANECOFUELS biofuel plants and modern Fuel Stations under a turn-key franchise model with full marketing, training and operations support.",
    accent: "#138808",
    options: [
      {
        id: "cbg-plant",
        title: "CBG Plant",
        subtitle: "Compressed Bio Gas Plant",
        desc: "Industrial-scale CBG production facility with feedstock pipeline, government grant support and offtake guarantee.",
        capex_hint: "₹15 Cr+ investment",
      },
      {
        id: "petrol-pump",
        title: "Biofuel Stations",
        subtitle: "Branded Retail Outlet",
        desc: "INDIANECOFUELS branded fuel station with bio-blended Fuels, EV charging readiness and premium customer experience.",
        capex_hint: "₹1.5–4 Cr investment",
      },
    ],
  },

  dealer: {
    id: "dealer",
    label: "Dealership",
    title: "Dealership Opportunities",
    tagline: "Run a profitable retail outlet on India's cleanest energy network.",
    desc: "Choose from multiple fuel dealership models designed for profitability and scalable growth.",
    accent: "#FF9933",
    options: [
      {
        id: "petrol-diesel-2-2",
        title: "Bio-Fuel Station",
        subtitle: "2 Nozzles · 2 Machines",
        desc: "Dual-fuel outlet with 1 petrol and 1 diesel dispenser. Ideal for entry-level multi-fuel operations.",
        capex_hint: "From ₹80 L",
      },
      {
        id: "petrol-diesel-4-2",
        title: "Bio-Fuel Station",
        subtitle: "4 Nozzles · 2 Machines",
        desc: "High-capacity dual-fuel outlet designed for busy highway and city locations.",
        capex_hint: "From ₹1.2 Cr",
      },
      {
        id: "petrol-diesel-cng",
        title: "Bio-Fuel Station+Bio-CNG",
        subtitle: "Full Multi-Fuel Station",
        desc: "Complete tri-fuel station with operational petrol, diesel, and CNG dispensing.",
        capex_hint: "From ₹2.2 Cr",
      },
      {
        id: "only-cng",
        title: "Bio-CNG",
        subtitle: "Dedicated CNG Station",
        desc: "Standalone CNG retail station focused on clean mobility and commercial fleets.",
        capex_hint: "From ₹1.8 Cr",
      },
    ],
  },
};

export function findOpportunity(type, optionId) {
  const group = OPPORTUNITIES[type];
  if (!group) return null;

  const option = group.options.find((o) => o.id === optionId);
  if (!option) return null;

  return { group, option };
}
